/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BucketValidatorDto } from '../models/bucket-validator-dto';
import { TransactionDto } from '../models/transaction-dto';
import { validatorControllerConfirmValidationTransaction } from '../fn/validator/validator-controller-confirm-validation-transaction';
import { ValidatorControllerConfirmValidationTransaction$Params } from '../fn/validator/validator-controller-confirm-validation-transaction';
import { validatorControllerCreateValidation } from '../fn/validator/validator-controller-create-validation';
import { ValidatorControllerCreateValidation$Params } from '../fn/validator/validator-controller-create-validation';
import { validatorControllerGetAllowedBuckets } from '../fn/validator/validator-controller-get-allowed-buckets';
import { ValidatorControllerGetAllowedBuckets$Params } from '../fn/validator/validator-controller-get-allowed-buckets';

@Injectable({ providedIn: 'root' })
export class ValidatorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `validatorControllerGetAllowedBuckets()` */
  static readonly ValidatorControllerGetAllowedBucketsPath = '/validator/bucket-validator';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validatorControllerGetAllowedBuckets()` instead.
   *
   * This method doesn't expect any request body.
   */
  validatorControllerGetAllowedBuckets$Response(params?: ValidatorControllerGetAllowedBuckets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BucketValidatorDto>>> {
    return validatorControllerGetAllowedBuckets(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validatorControllerGetAllowedBuckets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  validatorControllerGetAllowedBuckets(params?: ValidatorControllerGetAllowedBuckets$Params, context?: HttpContext): Observable<Array<BucketValidatorDto>> {
    return this.validatorControllerGetAllowedBuckets$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BucketValidatorDto>>): Array<BucketValidatorDto> => r.body)
    );
  }

  /** Path part for operation `validatorControllerCreateValidation()` */
  static readonly ValidatorControllerCreateValidationPath = '/validator/validation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validatorControllerCreateValidation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  validatorControllerCreateValidation$Response(params: ValidatorControllerCreateValidation$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionDto>> {
    return validatorControllerCreateValidation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validatorControllerCreateValidation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  validatorControllerCreateValidation(params: ValidatorControllerCreateValidation$Params, context?: HttpContext): Observable<TransactionDto> {
    return this.validatorControllerCreateValidation$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionDto>): TransactionDto => r.body)
    );
  }

  /** Path part for operation `validatorControllerConfirmValidationTransaction()` */
  static readonly ValidatorControllerConfirmValidationTransactionPath = '/validator/validation/{uuid}/confirm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validatorControllerConfirmValidationTransaction()` instead.
   *
   * This method doesn't expect any request body.
   */
  validatorControllerConfirmValidationTransaction$Response(params: ValidatorControllerConfirmValidationTransaction$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionDto>> {
    return validatorControllerConfirmValidationTransaction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validatorControllerConfirmValidationTransaction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  validatorControllerConfirmValidationTransaction(params: ValidatorControllerConfirmValidationTransaction$Params, context?: HttpContext): Observable<TransactionDto> {
    return this.validatorControllerConfirmValidationTransaction$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionDto>): TransactionDto => r.body)
    );
  }

}
